import 'datatables.net';
import 'jquery';

import type { DbServiceName, DbsTableDefData, DbsTableName } from '@comped/fe-shared/dist/dbs';

export type ClickTd = {
    target: JQuery<HTMLElement>;
    td: JQuery<HTMLElement>;
    tr: JQuery<HTMLElement>;
    row: DataTables.RowMethods;
    data: unknown;
    event: JQuery.TriggeredEvent & {
        preventDefault(): void;
        stopPropagation(): void;
    };
};
export type ClickTdHandler = (params: ClickTd) => void;

export type HasChildrenHandler = (params: ClickTd) => Promise<void> | void;

export type FunctionAjaxData = {
    start: number;
    length: number;
    draw: number;
    search?: {
        value?: string;
        regex?: boolean;
    };
    order: {
        column: number;
        dir: 'asc' | 'desc';
    }[];
    columns: {
        data: DataTables.ColumnSettings['data'];
        name: string;
        searchable: boolean;
        orderable: boolean;
        search?: {
            value?: string;
            regex?: boolean;
        };
    }[];
} & object;

export type FunctionAjaxBase<T> = (this:HTMLElement,
    data: FunctionAjaxData,
    callback: ((data: {
        draw: number;
        recordsTotal?: number | string;
        recordsFiltered?: number | string;
        data: T[];
    }) => void),
    settings: DataTables.SettingsLegacy & {
        SetLastQuery: (table: string, query: unknown) => void;
        SetLastResult: (table: Record<string, unknown>) => void;
    },
) => void;

export type FunctionAjax = FunctionAjaxBase<unknown>;
export type TypedApiFunctionAjax<S extends DbServiceName, T extends DbsTableName<S>> = FunctionAjaxBase<DbsTableDefData<S, T>>;

export interface TypedApiResponseColumn<T> extends DataTables.ColumnSettings {
    data?: T & string;
    skip?: boolean | (() => boolean);
}
export type DataTableApiResponseColumn<S extends DbServiceName, T extends DbsTableName<S>> = TypedApiResponseColumn<keyof DbsTableDefData<S, T>>;

export type DataTableColumn = DataTables.ColumnSettings;
export interface DataTableTypedColumn<O> extends DataTables.ColumnSettings {
    data?: (keyof O) & string;
}

export const DataTableUpdateType = {
    Soft: 1,
    Hard: 2,
    Full: 3,
} as const;
export type DataTableUpdateValues = typeof DataTableUpdateType[keyof typeof DataTableUpdateType];

export type DataTableApi = {
    queueUpdateType: (update: DataTableUpdateValues) => void;
    performUpdate: (update?: DataTableUpdateValues, forceImmediate?: boolean) => void;
};
